<template>
  <div>
    <Row>
      <Col span="8">
        <Card>
          <p slot="title">用户账号</p>
          <Scroll>
            <div
              v-for="item of Userlists"
              :key="item.UserID"
              :class="item.UserID === info.UserID?'ActiveUserlist':'Userlist'"
              @click="UserlisSelectHandleClick(item)"
            >
              <List>
                <ListItem>
                  <ListItemMeta title="账号" :description="item.UserID" />
                  <ListItemMeta title="用户名" :description="item.UserName" />
                </ListItem>
              </List>
            </div>
          </Scroll>
        </Card>
      </Col>
      <Col span="15" offset="1">
        <Collapse simple>
          <Panel :name="item.Menu_ID" v-for="(item, index) in JurisdictionList" :key="item.Menu_ID">
            {{ item.Menu_Name }}
            <div slot="content">
              <Collapse simple>
                <Panel
                  :name="item1.Menu_ID"
                  v-for="(item1, index1) in item.subsetlist"
                  :key="item1.Menu_ID"
                >
                  {{ item1.Menu_Name }}
                  <List slot="content">
                    <ListItem
                      v-for="(item2, index2) in item1.subsetlist"
                      :key="item2.Menu_ID"
                    >
                      <div class="function" :class="item2.isCheck?'isCheckfunction':'function'" @click="CheckHandleClick(index, index1, index2, item2.isCheck)">
                        <img v-if="item2.isCheck" class="checkimg" src="../../../images/check.png"/>
                        <img v-else="" class="checkimg" src="../../../images/uncheck.png"/>
                        {{ item2.Menu_Name }}
                      </div>
                    </ListItem>
                  </List>
                </Panel>
              </Collapse>
            </div>
          </Panel>
        </Collapse>
      </Col>
    </Row>
  </div>
</template>

<script>
import { JurisdictionUserinfo, JurisdictionData, ChangeJurisdiction } from '../../../api/Account.js'
export default {
  name: 'Jurisdiction',
  data () {
    return {
      Userlists: [],
      JurisdictionList: [],
      info: {
        UserID: '',
        UserName: '',
        State: 0
      },
      listStyle: {
        width: '250px',
        height: '300px'
      }
    }
  },
  mounted: function () {
    this.GetJurisdictionUserinfo()
  },
  methods: {
    GetJurisdictionUserinfo () {
      JurisdictionUserinfo().then(res => {
        if (res.IsSuccess) {
          this.Userlists = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 账号被选择后
    UserlisSelectHandleClick (item) {
      this.info = item
      this.GetJurisdictionData(item.UserID)
    },
    // 获取用户权限数据
    GetJurisdictionData (UserID) {
      JurisdictionData(UserID).then(res => {
        if (res.IsSuccess) {
          this.JurisdictionList = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 权限点击后回调
    CheckHandleClick (index, index1, index2, isCheck) {
      let check = isCheck
      if (check) {
        check = false
      } else {
        check = true
      }
      const menuid = this.JurisdictionList[index].subsetlist[index1].subsetlist[index2].Menu_ID
      ChangeJurisdiction(this.info.UserID, menuid, check).then(res => {
        if (res.IsSuccess) {
          this.JurisdictionList[index].subsetlist[index1].subsetlist[index2].isCheck = check
        } else {
          this.$Message.error(res.Message)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.ActiveUserlist ::v-deep .ivu-list-item-meta-title {
  color: #288cf0;
}
.ActiveUserlist ::v-deep .ivu-list-item-meta-description {
  color: #288cf0;
}
.Userlist {
  &:hover {
    background: #f3f3f3;
    cursor: pointer;
  }
}
.ActiveUserlist {
  background: #f0faff;
  color: #288cf0;
  &:hover {
    cursor: pointer;
  }
}
.function{
  &:hover {
    color: #c2c0cf;
    cursor: pointer;
  }
}
.isCheckfunction{
  color: #288cf0;
  &:hover {
    color: #87CEFA;
    cursor: pointer;
  }
}
.checkimg{
  height: 1rem;
  width: 1rem;
  margin-left: 2rem;
  margin-right: .5rem;
  margin-bottom: -.2rem;
}
</style>
